export default "__VITE_ASSET__DXCvEbjT__"